export default "__VITE_ASSET__Mvc3AlEX__"